import React from "react";
import classNames from "classnames";

const HubArticlesCard = ({ article }) => {
  return (
    <div
      className={`card hub-article ${article.featured ? "card--featured" : ""}`}
    >
      <div className="card__image">
        <img src={article.thumbnail} alt={article.thumbnailAlt} />
      </div>

      <div className="card__body">
        <h2 className="card__heading">
          <a href={article.targetURL} className="stretched-link link-unstyled">
            {article.title}
          </a>
        </h2>

        <div className="card__meta">
          <span>{article.lastModifiedDate}</span>
          <span>{article.businessName}</span>
        </div>

        <div className="card__content">
          <p>{article.summary}</p>
        </div>
      </div>

      <div className="card__footer">
        <ul className="card-topic-tags list-unstyled">
          <li>
            <span className="card-topic-tags__tag">
              {article.primaryTopic.value[0]}
            </span>
          </li>

          {article.secondaryTopic && (
            <li>
              <span className="card-topic-tags__tag">
                {article.secondaryTopic}
              </span>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default HubArticlesCard;
